import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'profile.preferredlanguage.empty': {
    id: 'profile.preferredlanguage.empty',
    defaultMessage: 'Add language',
    description: 'Instructions when the user doesn’t have a preferred language set.',
  },
  'profile.preferredlanguage.label': {
    id: 'profile.preferredlanguage.label',
    defaultMessage: 'Primary language spoken',
    description: 'The label for a user’s primary spoken language.',
  },
});

export default messages;
